import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { TTranslateTextType } from 'src/hooks/useTranslationHook';
import { Chip } from '@mui/material';

export const getScoreListGridColumns = (
  translateText: TTranslateTextType
): GridColDef[] => [
  {
    field: 'studentName',
    headerName: translateText('students.assessments.columns.studentName'),
    width: 200,
  },
  {
    field: 'className',
    headerName: translateText('students.assessments.columns.class'),
    width: 150,
  },
  {
    field: 'section',
    headerName: translateText('students.assessments.columns.section'),
    width: 100,
    renderCell: (params: GridRenderCellParams) => params.value || '-',
  },
  {
    field: 'academicYear',
    headerName: translateText('students.assessments.columns.academicYear'),
    width: 130,
  },
  {
    field: 'marks',
    headerName: translateText('students.assessments.columns.obtainedScore'),
    width: 130,
    type: 'number',
  },
  {
    field: 'maxMarks',
    headerName: translateText('students.assessments.columns.maxScore'),
    width: 120,
    type: 'number',
  },
  {
    field: 'percentage',
    headerName: translateText('students.assessments.columns.percentage'),
    width: 120,
    renderCell: (params: GridRenderCellParams) => `${params.value}%`,
  },
  {
    field: 'overallGrade',
    headerName: translateText('students.assessments.columns.grade'),
    width: 100,
    renderCell: (params: GridRenderCellParams) => (
      <Chip label={params.value} size="small" variant="outlined" />
    ),
  },
];



export const getAssessmentListGridColumns = (
  translateText: TTranslateTextType
): GridColDef[] => [
  {
    field: 'title',
    headerName: translateText('common.title'),
    width: 150,
  },
  {
    field: 'description',
    headerName: translateText('common.description'),
    width: 200,
  },
  {
    field: 'subject',
    headerName: translateText('students.assessments.columns.subject'),
    width: 150,
  },
  {
    field: 'class',
    headerName: translateText('students.assessments.columns.class'),
    width: 150,
  },
  {
    field: 'totalScore',
    headerName: translateText('students.assessments.columns.totalScore'),
    width: 120,
    type: 'number',
  },
  {
    field: 'totalPercentage',
    headerName: translateText('students.assessments.columns.totalPercentage'),
    width: 140,
    renderCell: (params: GridRenderCellParams) => {
      return `${params.value}%`;
    },
  },
  {
    field: 'expectedStudents',
    headerName: translateText('students.assessments.columns.expectedStudents'),
    width: 150,
    type: 'number',
  },
  {
    field: 'actualStudents',
    headerName: translateText('students.assessments.columns.actualStudents'),
    width: 140,
    type: 'number',
  },
  {
    field: 'passedStudents',
    headerName: translateText('students.assessments.columns.passedStudents'),
    width: 140,
    type: 'number',
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Chip
          label={params.value}
          size="small"
          color="success"
          variant="outlined"
        />
      );
    },
  },
  {
    field: 'failedStudents',
    headerName: translateText('students.assessments.columns.failedStudents'),
    width: 140,
    type: 'number',
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Chip
          label={params.value}
          size="small"
          color="error"
          variant="outlined"
        />
      );
    },
  },
  {
    field: 'passingScore',
    headerName: translateText('students.assessments.columns.passingScore'),
    width: 130,
    type: 'number',
  },
];

export const getStudentAssessmentDetailsGridColumns = (
  translateText: TTranslateTextType
): GridColDef[] => [
  {
    field: 'studentName',
    headerName: translateText('students.assessments.columns.studentName'),
    width: 200,
  },
  {
    field: 'obtainedScore',
    headerName: translateText('students.assessments.columns.obtainedScore'),
    width: 140,
    type: 'number',
  },
  {
    field: 'maxScore',
    headerName: translateText('students.assessments.columns.maxScore'),
    width: 120,
    type: 'number',
  },
  {
    field: 'percentage',
    headerName: translateText('students.assessments.columns.percentage'),
    width: 120,
    renderCell: (params: GridRenderCellParams) => {
      return `${params.value}%`;
    },
  },
  {
    field: 'date',
    headerName: translateText('students.assessments.columns.date'),
    width: 150,
    renderCell: (params: GridRenderCellParams) => {
      const date = new Date(params.value);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
  {
    field: 'remarks',
    headerName: translateText('students.assessments.columns.remarks'),
    width: 200,
  },
];
